import { AssetStatus } from '@risksmart-app/domain/src/types/consts/asset-status';
import { Asset_Status_Enum } from '@risksmart-app/web-graphql-client/generated/graphql';
import { z } from 'zod';

import {
  CustomAttributeDataSchema,
  FileOrRelationSchema,
  InheritedContributorSchema,
  NullableStringDateSchema,
  TagsAndDepartmentsSchema,
  UserOptionSchema,
  UserOrGroupsSchema,
} from './global';

const requiredMessage = 'Required';

export const AssetFormSchema = z
  .object({
    Title: z.string().min(1, { message: requiredMessage }),
    Status: z.nativeEnum(Asset_Status_Enum),
    Description: z.string().nullish(),
    AssetType: z.string().nullish(),
    SerialNumber: z.string().nullish(),
    PurchaseDate: NullableStringDateSchema,
    Location: z.string().nullish(),
    Cost: z.number().nullish(),
    DepreciationMethod: z.string().nullish(),
    Assignee: UserOptionSchema.nullish(),
    Contributors: UserOrGroupsSchema,
    Owners: UserOrGroupsSchema.min(1, { message: requiredMessage }),
    ancestorContributors: InheritedContributorSchema,
    files: z.array(FileOrRelationSchema),
  })
  .and(CustomAttributeDataSchema)
  .and(TagsAndDepartmentsSchema);

export type AssetFormFieldData = z.infer<typeof AssetFormSchema>;

export const defaultValues: AssetFormFieldData = {
  Title: '',
  Status: AssetStatus.Active,
  Description: '',
  AssetType: '',
  SerialNumber: '',
  PurchaseDate: null,
  Location: '',
  Cost: null,
  DepreciationMethod: '',
  Assignee: null,
  Owners: [],
  Contributors: [],
  ancestorContributors: [],
  files: [],
  CustomAttributeData: null,
  tags: [],
  departments: [],
};
